import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
let NumberDesign = class NumberDesign extends Vue {
    // @Prop({default:{}})
    // opts!:any
    render(h) {
        return h('a-input-number', { props: {
                disabled: true,
                placeholder: "请输入"
            } });
    }
};
NumberDesign = tslib_1.__decorate([
    Component({ name: 'NumberDesign' })
], NumberDesign);
export default NumberDesign;
